const isSSR = typeof window === "undefined";
export {
  isSSR
};
